var map = {
	"./after_1.jpg": 5325,
	"./after_2.jpg": 6098,
	"./after_3.jpg": 4159,
	"./after_4.jpg": 9524,
	"./after_5.jpg": 1329,
	"./before_1.jpg": 6610,
	"./before_2.jpg": 5837,
	"./before_3.jpg": 944,
	"./before_4.jpg": 9747,
	"./before_5.jpg": 9638,
	"./renovation_card.jpg": 8495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9791;